<div class="container-fluid">
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="page-title mb-0" translate>CACHES</h3>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary fs-6">
            <span translate>TOTAL_COUNT</span>: {{ cachesList.length }}
          </span>
          <button type="button" class="btn btn-outline-danger btn-sm" (click)="clearAllCache()">
            <i class="fa fa-trash me-1"></i>
            <span translate>CLEAR_ALL</span>
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="loadCache()">
            <i class="fa fa-sync me-1" [class.fa-spin]="loadingSize"></i>
            <span translate>RELOAD</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th scope="col" class="ps-3">
              <span translate>GUNG_CACHE_NAME</span>
              <i class="fa fa-question-circle text-muted ms-1 tooltip-icon" ngbTooltip="{{ 'GUNG_CACHE_NAME_TOOLTIP' | translate }}" container="body" placement="top"></i>
            </th>
            <th scope="col" class="text-end">
              <span translate>GUNG_CACHE_SIZE</span>
              <i class="fa fa-question-circle text-muted ms-1 tooltip-icon" ngbTooltip="{{ 'GUNG_CACHE_SIZE_TOOLTIP' | translate }}" container="body" placement="top"></i>
              <span *ngIf="loadingSize" class="spinner-border spinner-border-sm ms-1" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            </th>
            <th scope="col" class="text-end">
              <span translate>GUNG_CACHE_MEM</span>
              <i class="fa fa-question-circle text-muted ms-1 tooltip-icon" ngbTooltip="{{ 'GUNG_CACHE_MEM_TOOLTIP' | translate }}" container="body" placement="top"></i>
            </th>
            <th scope="col" class="text-end">
              <span translate>GUNG_CACHE_MAX_HEAP</span>
              <i class="fa fa-question-circle text-muted ms-1 tooltip-icon" ngbTooltip="{{ 'GUNG_CACHE_MAX_HEAP_TOOLTIP' | translate }}" container="body" placement="top"></i>
            </th>
            <th scope="col" class="text-center">
              <span translate>GUNG_CACHE_TTL</span>
              <i class="fa fa-question-circle text-muted ms-1 tooltip-icon" ngbTooltip="{{ 'GUNG_CACHE_TTL_TOOLTIP' | translate }}" container="body" placement="top"></i>
            </th>
            <th scope="col" class="text-center">
              <span translate>GUNG_CACHE_PRELOAD</span>
              <i class="fa fa-question-circle text-muted ms-1 tooltip-icon" ngbTooltip="{{ 'GUNG_CACHE_PRELOAD_TOOLTIP' | translate }}" container="body" placement="top"></i>
            </th>
            <th scope="col" class="text-center">
              <span translate>GUNG_CACHE_ACTIONS</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let cache of cachesList">
            <tr [class.table-warning]="cache.size > cache.maxEntriesLocalHeap && cache.maxEntriesLocalHeap > 0">
              <td class="ps-3">
                <div class="d-flex align-items-center">
                  <i *ngIf="cache.size > cache.maxEntriesLocalHeap && cache.maxEntriesLocalHeap > 0"
                     class="fa fa-exclamation-triangle text-warning me-2"
                     ngbTooltip="{{ 'GUNG_CACHE_HEAP_OVERFLOW' | translate }}" container="body"></i>
                  <span class="fw-medium">{{ cache.name }}</span>
                </div>
              </td>
              <td class="text-end">{{ cache.size | number }}</td>
              <td class="text-end">{{ cache.memoryStoreSize | number }}</td>
              <td class="text-end">
                <span *ngIf="cache.maxEntriesLocalHeap > 0">{{ cache.maxEntriesLocalHeap | number }}</span>
                <span *ngIf="cache.maxEntriesLocalHeap === 0" class="text-muted">-</span>
              </td>
              <td class="text-center">
                <span *ngIf="cache.eternal" class="badge bg-dark" translate>ETERNAL</span>
                <span *ngIf="!cache.eternal">{{ cache.timeToLiveSeconds }}s</span>
              </td>
              <td class="text-center">
                <i *ngIf="cache.preload === true" class="fa fa-check text-success"></i>
                <i *ngIf="cache.preload === false" class="fa fa-times text-muted"></i>
                <i *ngIf="cache.preload !== true && cache.preload !== false" class="fa fa-question text-warning"></i>
              </td>
              <td class="text-center">
                <div class="btn-group btn-group-sm">
                  <button type="button" class="btn btn-outline-secondary"
                          (click)="clearCache(cache.name)"
                          ngbTooltip="{{ 'CLEAR' | translate }}" container="body">
                    <i class="fa fa-eraser"></i>
                  </button>
                  <button type="button"
                          class="btn btn-outline-info"
                          (click)="toggleKeysVisibility(cache.name)"
                          [disabled]="keysLoadingMap[cache.name]"
                          ngbTooltip="{{ (keysShownMap[cache.name] ? 'HIDE_KEYS' : 'SHOW_KEYS') | translate }}" container="body">
                    <i *ngIf="!keysLoadingMap[cache.name]" class="fa" [ngClass]="keysShownMap[cache.name] ? 'fa-eye-slash' : 'fa-info-circle'"></i>
                    <i *ngIf="keysLoadingMap[cache.name]" class="fa fa-spinner fa-spin"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="keysShownMap[cache.name]" class="keys-row">
              <td colspan="7" class="p-0 border-0">
                <div class="keys-panel">
                  <div class="keys-header">
                    <strong translate>CACHE_KEYS</strong>
                    <span class="badge bg-secondary ms-2">{{ cacheKeysMap[cache.name]?.length || 0 }}</span>
                    <button type="button" class="btn-close ms-auto" (click)="keysShownMap[cache.name] = false"></button>
                  </div>
                  <div class="keys-content" *ngIf="cacheKeysMap[cache.name]?.length > 0">
                    <div *ngFor="let key of cacheKeysMap[cache.name]; trackBy: trackByKey" class="key-item">
                      <code class="key-text">{{ key }}</code>
                      <button type="button" class="btn btn-copy" (click)="copyToClipboard(key)"
                              ngbTooltip="{{ 'COPY' | translate }}" container="body">
                        <i class="fa fa-copy"></i>
                      </button>
                      <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteCacheKey(cache.name, key)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <div class="keys-empty" *ngIf="!cacheKeysMap[cache.name] || cacheKeysMap[cache.name].length === 0">
                    <span class="text-muted" translate>NO_KEYS</span>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
